import proposalSlice from "./proposal.slice";

export * from "./proposal.actions";
export * from "./proposal.saga";
export * from "./proposal.slice";

export default proposalSlice.reducer;
